import { useUserStore } from '@/entities/user/store';
import { useCategoriesStore } from '@/entities/category/store/category';
import { useLocationStore } from '@/entities/location/store/location';
import { ACCESS_TOKEN_COOKIE_NAME } from '@/shared/constants/cookiesConstants';

export const initApp = async (): Promise<void> => {
  const userStore = useUserStore();
  const categoriesStore = useCategoriesStore();
  const locationStore = useLocationStore();

  const accessToken = useCookie(ACCESS_TOKEN_COOKIE_NAME, { path: '/' });

  const requests: Promise<void>[] = [
    callOnce('init:categories', () => categoriesStore.getCategories()),
    callOnce('init:cities', () => locationStore.getCities()),
  ];

  if (accessToken.value) {
    const token = accessToken.value;
    requests.push(callOnce('init:user', () => userStore.getUser(token)));
  }

  await Promise.all(requests);
};

export default defineNuxtPlugin({
  name: 'init-app',
  dependsOn: ['services'],
  setup: () => initApp(),
});
